var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceMenuIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16V0L1.11059 0.877156L2.28856 0L3.46631 0.877156L4.64428 0L5.82203 0.877156L7 0L8.17797 0.877156L9.35572 0L10.5337 0.877156L11.7114 0L12.8894 0.877156L14 0V16L12.8894 15.1228L11.7114 16L10.5337 15.1228L9.35572 16L8.17797 15.1228L7 16L5.82203 15.1228L4.64428 16L3.46631 15.1228L2.28856 16L1.11059 15.1228L0 16ZM2.1875 11.5437H11.8125V10.6315H2.1875V11.5437ZM2.1875 8.45614H11.8125V7.54386H2.1875V8.45614ZM2.1875 5.36853H11.8125V4.45625H2.1875V5.36853ZM0.875 14.4772H13.125V1.52282H0.875V14.4772Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceMenuIc);
export default __webpack_public_path__ + "static/media/invoice-menu-ic.6894a17133f0f57e1e25f52845710a21.svg";
export { ForwardRef as ReactComponent };